import script from "./file-followers-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./file-followers-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__